import React from "react";
import classnames from "classnames";
import styles from "./Banner.module.scss";

/** Системные плашки под шапкой (FR-030); одновременно видна одна */
export type BannerKind = "offline" | "unsent" | "update";

export interface BannerProps {
    kind: BannerKind;
    text: string;
    /** Подпись кнопки действия («Обновить»); нет — плашка без кнопки */
    actionLabel?: string;
    onAction?: () => void;
    /** Касание всей плашки (например, «Не отправлено: N» открывает список); с кнопкой действия не сочетается */
    onClick?: () => void;
    className?: string;
}

/**
 * Плашка под шапкой: «Нет сети», «Не отправлено: N», «Доступна новая версия».
 * Объявляется скринридеру как статус (`role="status"`). Кнопка действия — зона касания 44 px.
 */
export const Banner = ({ kind, text, actionLabel, onAction, onClick, className }: BannerProps) =>
    onClick && !actionLabel ? (
        <div className={classnames(styles.banner, styles[kind], className)} role="status">
            <button type="button" className={styles.link} onClick={onClick}>
                {text}
            </button>
        </div>
    ) : (
        <div className={classnames(styles.banner, styles[kind], className)} role="status">
            <span className={styles.text}>{text}</span>
            {actionLabel && onAction && (
                <button type="button" className={styles.action} onClick={onAction}>
                    {actionLabel}
                </button>
            )}
        </div>
    );
